/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CardUser } from '../../models/card-user';

export interface ApiTapioGetCardDetailsGet$Json$Params {
  CARD_UID?: string;
  Authorization?: string;
}

export function apiTapioGetCardDetailsGet$Json(http: HttpClient, rootUrl: string, params?: ApiTapioGetCardDetailsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CardUser>> {
  const rb = new RequestBuilder(rootUrl, apiTapioGetCardDetailsGet$Json.PATH, 'get');
  if (params) {
    rb.query('CARD_UID', params.CARD_UID, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CardUser>;
    })
  );
}

apiTapioGetCardDetailsGet$Json.PATH = '/api/Tapio/GetCardDetails';
